/******/ (() => { // webpackBootstrap
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
/* ---
	Product Recommendations
--- */

if (typeof ProductRecommendations !== 'function') {
  var _ProductRecommendations = /*#__PURE__*/function (_HTMLElement) {
    function _ProductRecommendations() {
      var _this;
      _classCallCheck(this, _ProductRecommendations);
      _this = _callSuper(this, _ProductRecommendations);
      var event = new Event('product-recommendations-loaded');
      var handleIntersection = function handleIntersection(entries, observer) {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(_this);
        fetch(_this.dataset.url).then(function (response) {
          return response.text();
        }).then(function (text) {
          var innerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations');
          if (innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0) {
            _this.innerHTML = innerHTML.innerHTML;
            _this.querySelectorAll('form').forEach(function (elm) {
              if (elm.querySelector('template')) {
                elm.append(elm.querySelector('template').content.cloneNode(true));
              }
            });
            _this.dispatchEvent(event);
          }
        })["catch"](function (e) {
          console.error(e);
        });
      };
      new IntersectionObserver(handleIntersection.bind(_this), {
        rootMargin: "0px 0px 400px 0px"
      }).observe(_this);
      return _this;
    }
    _inherits(_ProductRecommendations, _HTMLElement);
    return _createClass(_ProductRecommendations);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  if (typeof customElements.get('product-recommendations') === 'undefined') {
    customElements.define('product-recommendations', _ProductRecommendations);
  }
}

/* ---
	Gift card recipent
--- */

if (typeof GiftCardRecipient !== 'function') {
  var _GiftCardRecipient = /*#__PURE__*/function (_HTMLElement2) {
    function _GiftCardRecipient() {
      var _this2$recipientCheck;
      var _this2;
      _classCallCheck(this, _GiftCardRecipient);
      _this2 = _callSuper(this, _GiftCardRecipient);
      var properties = Array.from(_this2.querySelectorAll('[name*="properties"]'));
      var checkboxPropertyName = 'properties[__shopify_send_gift_card_to_recipient]';
      _this2.recipientCheckbox = properties.find(function (input) {
        return input.name === checkboxPropertyName;
      });
      _this2.recipientOtherProperties = properties.filter(function (input) {
        return input.name !== checkboxPropertyName;
      });
      _this2.recipientFieldsContainer = _this2.querySelector('.gift-card-recipient__fields');
      (_this2$recipientCheck = _this2.recipientCheckbox) === null || _this2$recipientCheck === void 0 || _this2$recipientCheck.addEventListener('change', _this2.synchronizeProperties.bind(_this2));
      _this2.synchronizeProperties();
      return _this2;
    }
    _inherits(_GiftCardRecipient, _HTMLElement2);
    return _createClass(_GiftCardRecipient, [{
      key: "synchronizeProperties",
      value: function synchronizeProperties() {
        var _this3 = this;
        this.recipientOtherProperties.forEach(function (property) {
          return property.disabled = !_this3.recipientCheckbox.checked;
        });
        this.recipientFieldsContainer.classList.toggle('hide', !this.recipientCheckbox.checked);
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
  if (typeof customElements.get('gift-card-recipient') === 'undefined') {
    customElements.define('gift-card-recipient', _GiftCardRecipient);
  }
}
/******/ })()
;